
import { OlliCartUrl, OlliCoursesUrl } from "../directives/utilities/urls";
export default function olliMembershipOptions() {
    return {
        loadMembershipOptionList: [],
        showErrorMesage: false,
        isSubmitting: false,
        messsage: '',
        olliCoursesUrl: OlliCoursesUrl,
        bindLoadMembershipList() {
            let jsonData = JSON.stringify({
                //"AcademicYear": parseInt(urlParams.get('MembershipAcademicYear')),
                //"AcademicTerm": urlParams.get('MembershipAcademicTerm'),
            });
            fetch('/api/OlliCheckout/LoadMembership', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: jsonData
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        if (response.redirectToCheckout) {
                            window.location.href = OlliCartUrl;
                        } else if (response.showMembershipOptions) {
                            Array.prototype.push.apply(this.loadMembershipOptionList, response.membershipOptions);
                        }
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }
                });

        },
        nextStep(itemList) {
         var isValidRequest = false;

            if (itemList.length > 0) {
                var jsonData = {

                };
                for (var item = 0; item < itemList.length > 0; item++) {
                    if (itemList[item].selectedOption != null &&  itemList[item].selectedOption) {
                        jsonData = JSON.stringify({
                            "AcademicYear": itemList[item].academicYear,
                            "AcademicTerm": itemList[item].academicTerm,
                            "SerialId": itemList[item].serialId,
                            "SessionId": itemList[item].serialId,

                        });
                        isValidRequest = true;
                    }
                    
                }
                if (isValidRequest) {
                    this.isSubmitting = true;
                    fetch('/api/OlliCheckout/SaveMembership', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: jsonData
                    })
                        .then(response => {
                            return response.json();
                        }).then(login => {
                            this.isSubmitting = false;
                            if (login.isSuccess) {
                                window.location.href = OlliCartUrl;
                            }
                            else {
                                this.messsage = "Something went to wrong please try later.";
                            }

                        })
                } else {
                    this.messsage = "Please select the membership option.";
                }
            }
        },
        init() {
            this.bindLoadMembershipList();
        }
    }
}